import AdministratorRepo from './AdministratorRepo'
import {AdministratorDTO, AdministratorJSON} from '../DTO/AdministratorDTO'
import FetchWrapper from '../../../../Network/FetchWrapper'
import NewAdministratorDTO from '../DTO/NewAdministratorDTO'
import AdministratorsPasswordDTO from '../DTO/AdministratorsPasswordDTO'
import {DTO} from '../../../../Common/DtoUtilities'
import {CommonResponseDTO, CommonResponseJSON} from '../../../../Network/CommonResponse'
import {Nullable} from '../../../../Common/TypeHelper'
import {AdminBucketInfoDTO, AdminBucketInfoJSON} from '../DTO/AdminBucketInfoDTO'
import {AdministratorInformationDTO, AdministratorInformationJSON} from '../DTO/AdministratorInfomationDTO'
import {withAdminsAuth} from '../../../../Network/BrowserFetchWrapper'
import {AdminBaseInfoDTO, AdminBaseInfoJSON} from '../DTO/AdminBaseInfoDTO'
import {BucketAttributesDTO, BucketAttributesJSON} from '../DTO/BucketAttributesDTO'

class NetworkAdministratorRepo implements AdministratorRepo {
  private fetchWrapper: FetchWrapper
  private serverUrl = process.env.REACT_APP_MEMBUCKET_ADMIN_APP_SERVER_URL

  constructor(fetchWrapper: FetchWrapper) {
    this.fetchWrapper = fetchWrapper
  }

  create(newAdministratorDTO: NewAdministratorDTO): Promise<CommonResponseDTO<Nullable<number>>> {
    return this.fetchWrapper.postJson(`${this.serverUrl}/v1/a/r/managers`,
      DTO.toObject(newAdministratorDTO), withAdminsAuth(),
    ).then((response: CommonResponseJSON<number>) => {
      return new CommonResponseDTO(
        response.status,
        response.data,
        response.errorMessageList,
      )
    })
  }

  getList(): Promise<CommonResponseDTO<AdministratorDTO[]>> {
    return this.fetchWrapper.getByJson(`${this.serverUrl}/v1/a/r/managers`, withAdminsAuth())
      .then((response: CommonResponseJSON<AdministratorJSON[]>) => {
        return CommonResponseDTO.fromArray(
          response,
          AdministratorDTO.fromJSON,
        )
      })
  }

  getAdminInfo(oneTimeToken: string): Promise<CommonResponseDTO<AdminBaseInfoDTO>> {
    return this.fetchWrapper.getByJson(`${this.serverUrl}/v1/a/p/managers?one_time_token=${oneTimeToken}`)
      .then((response: CommonResponseJSON<AdminBaseInfoJSON>) => {
        return CommonResponseDTO.from(
          response,
          AdminBaseInfoDTO.fromJSON,
        )
      })
  }

  registerPassword(
    administratorsPasswordDTO: AdministratorsPasswordDTO,
  ): Promise<CommonResponseDTO<Nullable<number>>> {
    return this.fetchWrapper.postJson(`${this.serverUrl}/v1/a/p/managers/activate`,
      DTO.toObject(administratorsPasswordDTO),
    ).then((response: CommonResponseJSON<Nullable<number>>) => {
      return new CommonResponseDTO(
        response.status,
        response.data,
        response.errorMessageList,
      )
    })
  }

  getAdminBucketInfoList(): Promise<CommonResponseDTO<AdminBucketInfoDTO[]>> {
    return this.fetchWrapper.getByJson(`${this.serverUrl}/v1/a/r/buckets`, withAdminsAuth())
      .then((response: CommonResponseJSON<AdminBucketInfoJSON[]>) => {
        return CommonResponseDTO.fromArray(
          response,
          AdminBucketInfoDTO.fromJSON,
        )
      })
  }

  getInformation(): Promise<CommonResponseDTO<AdministratorInformationDTO>> {
    return this.fetchWrapper.getByJson(`${this.serverUrl}/v1/a/r/managers/self`, withAdminsAuth())
      .then((response: CommonResponseJSON<AdministratorInformationJSON>) => {
        return CommonResponseDTO.from(
          response,
          AdministratorInformationDTO.fromJSON,
        )
      })
  }

  getAdminBucketInfo(bucketKey: string): Promise<CommonResponseDTO<AdminBucketInfoDTO>> {
    return this.fetchWrapper.getByJson(`${this.serverUrl}/v1/a/r/buckets/${bucketKey}`,
      withAdminsAuth())
      .then((response: CommonResponseJSON<AdminBucketInfoJSON>) => {
        return CommonResponseDTO.from(
          response,
          AdminBucketInfoDTO.fromJSON,
        )
      })
  }

  getBucketAttributes(
    bucketKey: string,
  ): Promise<CommonResponseDTO<Nullable<BucketAttributesDTO>>> {
    return this.fetchWrapper.getByJson(
      `${this.serverUrl}/v1/a/r/buckets/${bucketKey}/attributes`,
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<BucketAttributesJSON>) => {
      return CommonResponseDTO.from(
        response,
        BucketAttributesDTO.fromJSON,
      )
    })
  }

  postLogout(): Promise<CommonResponseDTO<null>> {
    return this.fetchWrapper.postJson(
      `${this.serverUrl}/v1/a/r/managers/self/logout`,
      {},
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<null>) =>
      CommonResponseDTO.ofNullData(response),
    )
  }
}

export default NetworkAdministratorRepo
